import React from 'react';
import { Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import SelectCourse from './SelectCourse';
import { Route } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class ActiveExams extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (

            <div>
                <Header as="h1"><FormattedMessage id="professorInputGrades.activeCourse" /></Header>

                <FormattedMessage id="route.active">
                    {(msg) => (<SelectCourse msg={msg} />)}
                </FormattedMessage>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/ActiveExams.js